import React from 'react';
import { Server } from '../../server/server';
import { AppConfig } from '../AppConfig';
import { getDeviceType, getSiteSubDomain } from '../util/util';
import './SitePage.css';
import PageEnvelope from '../elements/PageEnvelope';
import LoginModal from '../modals/LoginModal';
import reactManifest from "react-manifest";

let COMMUNITY_VERSION = 1;

interface SplacePageProps {
  onInit: Function;
}

interface SplashPageState {
  loading: boolean;
  maintenance: boolean;
  ticker: string;
  welcome: boolean;
  accept: boolean;
  decline: boolean;
  invite: any;
  inviteId: string;
  autoDecline: boolean;
  declining: string;
  community: boolean;
  login: string;
}

class SplashPage extends React.Component<SplacePageProps, SplashPageState> {
  constructor(props: SplacePageProps) {
    super(props);
    this.state = {
      loading: true,
      maintenance: false,
      ticker: '',
      welcome: false,
      accept: false,
      decline: false,
      invite: null,
      inviteId: '',
      autoDecline: false,
      declining: '',
      community: false,
      login: ''
    }
  }

  componentDidMount(): void {
    this.loadPage();
  }

  async loadPage() {
    let slug = getSiteSubDomain();

    if(slug == 'www') {
      AppConfig.update();
      await Server.init();
      this.autoLogin();
    }
    else
      this.loadCommunity(slug);
  }

  async loadCommunity(slug:string) {
    // window.localStorage.removeItem('Community-' + slug);

    let loadedFromCache = false;

    let item = window.localStorage.getItem('Community-' + slug);

    if(item) {
      let community = JSON.parse(item);
      if(community.version == COMMUNITY_VERSION) {
        loadedFromCache = true;
        AppConfig.setCommunity(community);
        this.loadCommunityFromServer(slug);
      }
    }

    if(!loadedFromCache) 
      await this.loadCommunityFromServer(slug);

    this.setState({community: true})

    await Server.init(AppConfig.community.id);

    let invited = (window.location.pathname == '/invite');

    if(invited)
      this.processInvite();
    else
      this.autoLogin();
  }

  async loadCommunityFromServer(slug:string) {
    let response = await Server.public.loadCommunity(slug);

    if(response.success) {
      AppConfig.setCommunity(response.community);
      window.localStorage.setItem('Community-' + slug, JSON.stringify(response.community));
    }
  }

  async processInvite() {
    let accept = false;
    let decline = false;
    let invite = null;
    let inviteId = '';

    if(window.location.search != '') {
      let parts = window.location.search.split('=');
      if(parts.length == 2) {
        accept = (parts[0] == '?accept');
        decline = (parts[0] == '?decline');
        inviteId = parts[1];

        if(accept || decline) {
          let response:any = await Server.public.getCommunityInvite(inviteId);
          if(response.success) 
            invite = response.invite;
        }
      }
    }

    this.setState({accept, decline, invite, inviteId});
  }

  async autoLogin() {
    if(AppConfig.community) {
      let icon = AppConfig.community.icon;
      if (icon.indexOf('https://s3.us-west-2.amazonaws.com/oneclick.media') !== -1) 
        icon = icon.replace('https://s3.us-west-2.amazonaws.com/oneclick.media', 'https://d27jhqexqrz634.cloudfront.net');

      if(getDeviceType() != 'desktop' && AppConfig.community.mobile)
        icon = AppConfig.community.mobile;

      const manifestDetails = {
        name: AppConfig.community.name,
        short_name: AppConfig.community.name,
        start_url: window.location.origin,
        display: 'standalone',
        orientation: 'any',
        theme_color: '#000000',
        background_color: '#ffffff',
        icons: [
          {
            src: icon,
            sizes: '256x256'
          }
        ]
      };
  
      reactManifest.update(manifestDetails, "#manifest-placeholder");
    }

    let response = await Server.autoLogin();

    if(!response.success && AppConfig.community && !AppConfig.community.public)
      this.setState({welcome: true});
    else
      this.props.onInit();
  }

  renderMaintenance() {
    return (
      <div className="site-page">
        <div style={{textAlign: 'center'}}>We will be right back!</div>
      </div>
    );
  }

  onGuest() {
    this.props.onInit();
  }

  onLogin(mode:string) {
    this.setState({login: mode});
  }

  onLoginClose() {
    this.setState({login: ''});
    if(Server.account.isLoggedIn())
      this.props.onInit();
  }

  onCancelAccept() {
    this.setState({accept: false, decline: true})
  }

  onCancelDecline() {
    this.setState({accept: true, decline: false})
  }

  onDecline() {
    this.setState({declining: 'Declining invitation...'});

    setTimeout(async () => {
      let response = await Server.public.declineCommunityInvite({id: this.state.inviteId, unsubscribe: this.state.autoDecline});

      if(response.success)
        this.setState({declining: 'The invitation has been declined.  You can now close this browser window.'});
      else
        this.setState({declining: response.message});
    }, 500);
  }

  renderLogo() {
    if(AppConfig.logo)
      return <img style={{width: '150px'}} src={AppConfig.logo} />;
    else
      return <div style={{fontSize: '1.5em', fontWeight: 'bold'}}>{AppConfig.title}</div>;
  }

  renderInvalidInvite() {
    if(!this.state.invite) {
      return (
        <div>This invitation has expired.</div>
      )
    }
  }

  renderInviteAccept() {
    return (
      <div className="site-page-column" style={{rowGap: '20px'}}>
        <div className="site-page-column" style={{alignItems: 'center'}}>
          <div>You have been invited by <b>{this.state.invite.sender}</b> to join the <b>{AppConfig.title}</b> community.</div>
          <button style={{width: '200px'}} onClick={()=>this.onLogin('signup')}>Create Account</button>
        </div>
          
        {AppConfig.community.public &&
          <div className="site-page-column" style={{alignItems: 'center'}}>
            <div className="site-page-subtext">If you would like to browse around before creating an account:</div>
            <button style={{width: '200px'}} onClick={()=>this.onGuest()}>View as Guest</button>
          </div>
        }

        <div className="site-page-column" style={{alignItems: 'center'}}>
          <div className="site-page-subtext">If you already have a<br/>OneClick Community account:</div>
          <button style={{width: '200px'}} onClick={()=>this.onLogin('login')}>Login with OCC</button>
        </div>

        <div style={{width: '100%', height: '1px', backgroundColor: 'var(--panel-subtext-color)'}} />

        <div className="site-page-column" style={{alignItems: 'center'}}>
          <div className="site-page-subtext">If you would rather not join the community at this time:</div>
          <button style={{width: '200px'}} onClick={()=>this.onCancelAccept()}>Decline Invite</button>
        </div>
      </div>
    )
  }

  renderInviteDecline() {
    if(this.state.declining != '') 
      return <div>{this.state.declining}</div>

    return (
      <div className="site-page-column" style={{rowGap: '20px'}}>
        <div>Are you sure that you want to decline the invitation from <b>{this.state.invite.sender}</b> to join the <b>{AppConfig.title}</b> community?</div>
        <div className="site-page-row" style={{columnGap: '50px', justifyContent: 'center'}}>
          <button style={{width: '120px'}} onClick={()=>this.onDecline()}>Yes</button>
          <button style={{width: '120px'}} onClick={()=>this.onCancelDecline()}>No</button>
        </div>
        <div className="site-page-row" style={{textAlign: 'left'}}>
            <input 
              type="checkbox" 
              checked={this.state.autoDecline} 
              onChange={(e:any)=>this.setState({autoDecline: e.currentTarget.checked})}
              style={{width: '20px', height: '20px'}} 
            />
            <div className="site-page-subtext">Decline all future invitations to join this community</div>
          </div>
      </div>
    )
  }

  renderWelcome() {
    return (
      <div className="site-page">
        <PageEnvelope width="450px">
          <div className="site-page-column">
            <div className="site-page-row" style={{justifyContent: 'center'}}>
              <div className="site-page-panel" style={{maxWidth: '350px', padding: '20px', rowGap: '20px', textAlign: 'center'}}>
                <div>{this.renderLogo()}</div>
                <div>Welcome to the <b>{AppConfig.title}</b> private community site.  An invitation is required for membership.</div>
                <div className="site-page-column" style={{alignItems: 'center'}}>
                  <button style={{width: '200px'}} onClick={()=>this.onLogin('login')}>Login</button>
                </div>
              </div>
            </div>
          </div>
        </PageEnvelope>
        <LoginModal mode={this.state.login} onClose={()=>this.onLoginClose()}/>
      </div>
    )
  }

  render() {
    if(this.state.maintenance)
      return this.renderMaintenance();

    if(this.state.welcome)
      return this.renderWelcome();

    if(!this.state.community)
      return null;

    let content = <div>Please wait...</div>;

    if(this.state.accept || this.state.decline) {
      if(!this.state.invite) 
        content = this.renderInvalidInvite();
      else if(this.state.accept)
        content = this.renderInviteAccept();
      else if(this.state.decline)
        content = this.renderInviteDecline();
    }
    
    return (
      <div className="site-page">
        <PageEnvelope width="450px">
          <div className="site-page-column">
            <div className="site-page-row" style={{justifyContent: 'center'}}>
              <div className="site-page-panel" style={{width: '350px', padding: '20px', rowGap: '20px', textAlign: 'center'}}>
                <div>{this.renderLogo()}</div>
                {content}
              </div>
            </div>
          </div>
        </PageEnvelope>
        <LoginModal mode={this.state.login} onClose={()=>this.onLoginClose()}/>
      </div>
    )
  }
}

export default SplashPage;

